import React from "react";

import { Avatar } from "@mui/material";

const UserAvatar = ({ src, dimention }) => {
  return (
    <Avatar
      alt="Remy Sharp"
      src={src}
      sx={{ width: dimention || "60px", height: dimention || "60px" }}
    />
  );
};

export default UserAvatar;
